import type { Options, TooltipOptions } from "highcharts";
import { renderToString } from "react-dom/server";

import { tooltipContainerConfig } from "@similarweb/pro-logic-components";
import { LegendWithOneLineBulletFlex } from "@similarweb/ui-components";

import { percentageFilter } from "app/filters/ngFilters";

const tooltipConfig: TooltipOptions = {
    outside: true,
    headerFormat: "",
    useHTML: true,
    ...tooltipContainerConfig().tooltip,
    pointFormatter() {
        return renderToString(
            <LegendWithOneLineBulletFlex
                text={this.name}
                value={`${percentageFilter()(this.y, 0)}%`}
                labelColor={this.color as string}
            />,
        );
    },
};

export const graphConfig: Options = {
    chart: {
        height: 148,
        width: 148,
        margin: 0,
        spacing: [0, 0, 0, 0],
        plotBorderWidth: 0,
    },
    // @ts-ignore text: null is intentional - undefined would show default title
    title: { text: null },
    legend: { enabled: false },
    credits: { enabled: false },
    tooltip: tooltipConfig,
    plotOptions: {
        series: {
            states: {
                hover: {
                    halo: {
                        size: 10,
                    },
                },
            },
        },
        pie: {
            size: "100%",
            center: ["50%", "50%"],
            borderWidth: 0,
            borderRadius: 0,
            dataLabels: {
                enabled: false,
                connectorWidth: 0,
            },
        },
    },
};
